import React from "react";
import Create from "modules/formTemplates/components/Create";

const FormTemplateCreatePage = () => {
  return <Create />;
};

export default FormTemplateCreatePage;
